import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import MyChartDataTile from "../dashboard/MyChartDataTile";
import Cookies from "cookies-js";
import * as Tools from "../../helpers/Tools";

export default class HealthSummaryPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = { openModal: false };
        this.toggleModal = this.toggleModal.bind(this);
        this.print = this.print.bind(this);
        this.isSafari = Tools.isSafari();
    }

    toggleModal() {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    setUrl(healthSummaryType) {
        let mode = "";
        switch (healthSummaryType.toLowerCase()) {
            case 'current health issues':
                mode = "hlthissues";
                break;
            case 'medications':
                mode = "medslist";
                break;
            case 'allergies':
                mode = "allergies";
                break;
            case 'immunizations':
                mode = "immunizations";
                break;
            case 'preventive care':
                mode = "healthmaint";
                break;
            case 'all records':
                mode = "snapshot";
                break;
        }

        this.setState({ mode }, () => { this.toggleModal(); });

    }

    readCurrentLanguage() {
        let localization = "";
        if (Cookies.get('BSWLOCAL'))
            localization = Cookies.get('BSWLOCAL');
        if (localization && localization.length > 0)
            return localization;
        else
            return "english";
    }

    print() {
        const { mode } = this.state;
        const iFrameId = "#mychart_print" + mode + " iframe";
        var iFrame = document.querySelector(iFrameId);
        if (!iFrame) return;
        var contentWindow = iFrame.contentWindow;
        if (contentWindow.document.getElementById("frmMyChart")) {
            iFrame = contentWindow.document.getElementById("frmMyChart");
            contentWindow = iFrame.contentWindow;
        }
        contentWindow.focus();
        contentWindow.print();
        this.toggleModal();
    }

    render() {
        const { serverData, healthSummaryTypes } = this.props;
        const { mode } = this.state;
        const id = "mychart_print" + mode;

        return (<div className="healthSummary-print-container">
            <div className="row">
                <div className="col-12">
                    <h3 className="health-summary-heading">Which records would you like to print?</h3>
                </div>
                <div className="col-12 health-summary-list">
                    {healthSummaryTypes && healthSummaryTypes.length > 0 &&
                        healthSummaryTypes.map((healthSummaryType, index) =>
                            <div className="form-group" key={index}>
                                <button className="btn btn-primary" onClick={() => { this.setUrl(healthSummaryType); }}>
                                    {healthSummaryType.toUpperCase()}
                                </button>
                            </div>
                        )
                    }
                    {mode &&
                        <Modal className="iframe-modal healthSummary-print-modal" isOpen={this.state.openModal} toggle={this.toggleModal} centered>
                            <ModalHeader toggle={this.toggleModal} />
                            <div>
                                <button className="btn btn-primary" onClick={this.print}>PRINT THIS RECORD</button>
                            </div>
                            <ModalBody id={id}>
                                <div className="white-cover" />
                                <MyChartDataTile
                                    mode={mode}
                                    navigation="hide"
                                    partialView
                                    serverData={serverData}
                                    showLanguageLink={false}
                                    src={`${serverData.myChartVisitsDataTileUrl}${mode}&m=null&printmode=true&lang=${this.readCurrentLanguage()}`}
                                />
                            </ModalBody>
                        </Modal>
                    }
                    {this.isSafari && <p className="hint-text">Having trouble printing? Please refresh the page.</p>}
                </div>
            </div>
        </div>);
    }
}